import * as React from "react"
import {Box, Typography} from "@mui/material";


export default function AppWrapperPageTitle({ title=null, subtitle=null, ...props }) {
    return <Box {...props?.containerTitleProps}>
		<Typography variant="h4" {...props?.titleProps} sx={{ mb: subtitle ? 0 : 2, ...props?.titleProps?.sx }}>
			{title}
		</Typography>
		{ subtitle && <Typography variant="body1" {...props?.subtitleProps} sx={{ mb: 2, ...props?.subtitleProps?.sx }}>
			{subtitle}
		</Typography> }
    </Box>
}